import  { createContext } from 'react';

export const LineContext = createContext( {

  line : null,
  setLine : ()=>{}

});